var _g, _circle, _circle2, _g2, _g3, _path, _path2, _path3, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoiceEffect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 234,
    viewBox: "0 0 233 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Voice Effect"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VoiceGlobe"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 184",
    opacity: 0.5,
    filter: "url(#filter0_f_3201_8122)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 117,
    r: 66.25,
    fill: "url(#paint0_linear_3201_8122)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 188",
    cx: 116.5,
    cy: 117,
    r: 60.9984,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 181",
    cx: 116.5,
    cy: 117,
    r: 60.4984,
    fill: "url(#paint1_linear_3201_8122)",
    stroke: "url(#paint2_linear_3201_8122)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 185",
    filter: "url(#filter1_f_3201_8122)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 117,
    r: 57.1267,
    stroke: "url(#paint3_linear_3201_8122)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 186",
    filter: "url(#filter2_f_3201_8122)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.501,
    cy: 117,
    r: 57.3767,
    stroke: "url(#paint4_linear_3201_8122)",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 182",
    d: "M167.276 117C167.276 145.043 144.543 167.776 116.5 167.776C88.4573 167.776 65.7241 145.043 65.7241 117C65.7241 88.9574 84.6365 128.997 112.679 128.997C140.722 128.997 167.276 88.9574 167.276 117Z",
    fill: "url(#paint5_linear_3201_8122)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 183",
    d: "M167.276 117C167.276 145.043 123.146 106.678 95.103 106.678C67.0602 106.678 65.7241 145.043 65.7241 117C65.7241 88.9574 88.4573 66.2242 116.5 66.2242C144.543 66.2242 167.276 88.9574 167.276 117Z",
    fill: "url(#paint6_linear_3201_8122)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 187",
    d: "M167.276 117.001C167.276 129.514 146.737 153.271 118.694 153.271C90.6511 153.271 65.7241 134.039 65.7241 117.001C65.7241 88.9578 78.2068 122.161 106.25 122.161C134.292 122.161 167.276 88.9578 167.276 117.001Z",
    fill: "url(#paint7_linear_3201_8122)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 189",
    style: {
      mixBlendMode: "screen"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 117,
    r: 50.776,
    fill: "url(#paint8_linear_3201_8122)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3201_8122",
    x: 0.25,
    y: 0.75,
    width: 232.5,
    height: 232.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_3201_8122"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3201_8122",
    x: 52.373,
    y: 52.8734,
    width: 128.254,
    height: 128.254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25,
    result: "effect1_foregroundBlur_3201_8122"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3201_8122",
    x: 55.5738,
    y: 56.0734,
    width: 121.854,
    height: 121.854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65,
    result: "effect1_foregroundBlur_3201_8122"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3201_8122",
    x1: 17.4562,
    y1: 212.731,
    x2: 190.369,
    y2: 38.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#834C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3201_8122",
    x1: 25.629,
    y1: 209.413,
    x2: 184.658,
    y2: 44.9472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25253A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6437B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3201_8122",
    x1: 25.3077,
    y1: 205.143,
    x2: 184.514,
    y2: 45.0221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#834C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3201_8122",
    x1: 30.6513,
    y1: 204.305,
    x2: 180.89,
    y2: 48.9298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25253A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6437B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3201_8122",
    x1: 30.652,
    y1: 204.305,
    x2: 180.89,
    y2: 48.9298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25253A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6437B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3201_8122",
    x1: 71.1099,
    y1: 145.736,
    x2: 170.43,
    y2: 129.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD14A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD14A5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3201_8122",
    x1: 164.571,
    y1: 125.649,
    x2: 75.0158,
    y2: 90.7753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C171FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#534AD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3201_8122",
    x1: 164.571,
    y1: 125.649,
    x2: 75.0158,
    y2: 90.7756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54ECD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#534AD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3201_8122",
    x1: 116.5,
    y1: 66.2242,
    x2: 177.521,
    y2: 124.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceEffect);
export default __webpack_public_path__ + "static/media/voice-effect.e93aba26d228011c7f395ead7e023ac3.svg";
export { ForwardRef as ReactComponent };